<template>
  <div>
    <section class="page-nav">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <StepsHeader :active="1" />
          </div>
        </div>
      </div>
    </section>

    <section class="search-branch mt-20">
      <div class="container">
        <div class="row">
          <div class="col-md-9">
            <div class="search-box">
              <span class="search-box--icon">
                <svg
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 30 30"
                  width="30px"
                  height="30px"
                >
                  <path
                    d="M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z"
                  />
                </svg>
              </span>

              <input
                v-model="search"
                class="search-box--input"
                type="text"
                :placeholder="$t('step-1.search')"
              />
            </div>
          </div>
          <div class="col-md-3 mt-12 mt-md-0">
            <div class="map-switch">
              <button
                @click="showList = !showList"
                :class="showList ? 'active' : ''"
                class="map-switch--button"
              >
                {{ $t("step-1.list-view") }}
              </button>
              <button
                @click="showList = !showList"
                :class="!showList ? 'active' : ''"
                class="map-switch--button"
              >
                {{ $t("step-1.map-view") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="list-branches my-20" v-if="showList">
      <div class="container">
        <div class="row">
          <div
            class="col-md-6 col-lg-4 mb-20"
            v-for="branch in filteredBranches"
            :key="branch.id"
          >
            <BranchList :branch="branch" :mapKey="googleMapKey" />
          </div>
        </div>
      </div>
    </section>

    <section class="my-20" v-if="!showList">
      <div class="container-fluid px-0">
        <div class="row no-gutters">
          <div class="map col-12">
            <div class="map__container">
              <google-map
                :config="mapConfig"
                apikey="AIzaSyDsOb4aLS30TmIyJlwQiYMoW93cFle1S0o"
              >
                <GoogleMapMarkers
                  :selected="selectedBranch"
                  :markers="filteredBranches"
                  @mapBranchActivated="mapBranchActivatedHandler"
                />
              </google-map>
            </div>
            <div class="map__list">
              <div class="map__branches">
                <template v-for="branch in filteredBranches">
                  <BranchMap
                    @selectedBranchMap="selectedBranchMapHandler"
                    :branch="branch"
                    :key="branch.id"
                    :selected="selectedBranch"
                  />
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import BranchList from "../components/BranchList.vue";
import BranchMap from "../components/BranchMap.vue";
import StepsHeader from "../components/StepsHeader.vue";

import GoogleMap from "../components/gmap/GoogleMap";
import GoogleMapMarkers from "../components/gmap/GoogleMapMarkers";
import API from "@/services/api";
import RouterActions from "@/mixins/routerActions";

export default {
  mixins: [RouterActions],
  components: {
    BranchList,
    BranchMap,
    StepsHeader,
    GoogleMap,
    GoogleMapMarkers,
  },
  data() {
    return {
      showList: true,
      mapConfig: {
        zoom: 12,
        center: {
          lat: 40.3754434,
          lng: 49.8326748,
        },
        styles: [
          {
            elementType: "geometry",
            stylers: [
              {
                color: "#f5f5f5",
              },
            ],
          },
          {
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#f5f5f5",
              },
            ],
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#bdbdbd",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
              {
                color: "#eeeeee",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                color: "#e5e5e5",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff",
              },
            ],
          },
          {
            featureType: "road.arterial",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
              {
                color: "#dadada",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
          {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [
              {
                color: "#e5e5e5",
              },
            ],
          },
          {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [
              {
                color: "#eeeeee",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#c9c9c9",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
        ],
      },
      branches: [],
      googleMapKey: process.env.VUE_APP_MAP_KEY,
      search: "",
      selectedBranch: {},
    };
  },
  computed: {
    filteredBranches() {
      return this.branches.filter((item) => {
        if (
          item.name.toLowerCase().indexOf(this.search) > -1 ||
          item.address.toLowerCase().indexOf(this.search) > -1 ||
          item.hours.toLowerCase().indexOf(this.search) > -1 ||
          item.numbers.toLowerCase().indexOf(this.search) > -1
        ) {
          return true;
        }
      });
    },
  },
  methods: {
    selectedBranchMapHandler(branch) {
      this.mapConfig.center.lat = branch.lat;
      this.mapConfig.center.lng = branch.long;
      this.selectedBranch = branch;
    },
    mapBranchActivatedHandler(branch) {
      this.selectedBranch = branch;
    },
    async getBranches() {
      this.branches = await API.getBranches();
    },
  },
  created() {
    this.getBranches();
  },
};
</script>
